import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { DateRangeColumnFilter, isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { deletedFilters, tableContainer } from "helpers/redux";
import React from "react";
import { getAllUsersForSelectList } from "sources/admin";
import { restore } from "sources/books/admin/regionDryingPeriods";
import { getFederalSubjects } from "sources/map";
import RegionDryingPeriodsForm from "./form";

class RegionDryingPeriods extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams("region-drying-periods", deletedFilters());
    }

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Регион",
                accessor: "regionName",
                id: "regionId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: getFederalSubjects, inputProps: { name: "regionId" }, propName: "name" }}
                    />
                ),
                Cell: ({ value, row: { original } }) => (
                    <div
                        className="link"
                        onClick={() =>
                            this.props.modal({
                                title: "Изменение зоны",
                                name: "default",
                                windowMod: "wide",
                                CustomBody: (props) => (
                                    <RegionDryingPeriodsForm
                                        {...props}
                                        data={original}
                                        mergeParams={this.props.mergeParams}
                                    />
                                ),
                            })
                        }
                    >
                        {value}
                    </div>
                ),
            },
            {
                Header: "Описание",
                accessor: "description",
                filterable: true,
            },
            {
                Header: "Пользователь",
                accessor: "userDisplayName",
                id: "updatedById",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllUsersForSelectList,
                            inputProps: { name: "updatedById" },
                            propName: "fullNameOrEmail",
                        }}
                    />
                ),
            },
            {
                Header: "Дата начала",
                accessor: "startedAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateRange",
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY"),
            },
            {
                Header: "Дата окончания",
                accessor: "endedAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateRange",
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY"),
            },
            {
                Header: "Дата последнего обновления",
                accessor: "updatedAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateTimeRange",
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            isDeletedColumn(
                (id) =>
                    this.props.modal({
                        name: "confirm",
                        title: "Вы действительно хотите восстановить?",
                        action: () => restore({ id }).then(() => this.props.mergeParams({})),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    }),
                true,
            ),
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;

        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () =>
                modal({
                    title: "Добавление зоны",
                    name: "default",
                    windowMod: "wide",
                    CustomBody: (props) => <RegionDryingPeriodsForm {...props} mergeParams={mergeParams} />,
                }),
        };
        return <div {...props}>Добавить зону</div>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list">
                        <div className="book-list__head-wrap">
                            <div className="book-list__head">
                                <div className="book-list__head-close close close--sm" onClick={this.close} />
                                <div className="book-list__head-title">
                                    Зоны просушек
                                    {this.renderCounter()}
                                </div>
                                <div className="btn-toolbar">
                                    {this.props.canEditBooks && this.renderCreateButton()}
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(RegionDryingPeriods, "region-drying-periods");
